module.exports = __webpack_public_path__ + "static/media/armenian.bb7f2c6f.png";